import React from "react";
import { ToggleButtonDiv } from "./Button.style";
import { Button } from "./Button";

const ToggleButton = ({
  setActiveButton,
  activeButton,
  btn1text,
  btn2text,
}) => {
  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  return (
    <ToggleButtonDiv>
      <Button
        text={btn1text || "Personal"}
        fontSize="14px"
        width="250px"
        height="40px"
        padding="0px"
        margin="5px"
        borderRadius="10px"
        backgroundColor={
          activeButton === "Personal"
            ? "rgba(0, 173, 239, 1)"
            : "rgba(239, 243, 253, 1)"
        }
        color={activeButton === "Personal" ? "white" : "black"}
        onClick={() => handleButtonClick("Personal")}
      />
      <Button
        text={btn2text || "Business"}
        fontSize="14px"
        width="250px"
        height="40px"
        padding="0px"
        margin="5px"
        borderRadius="10px"
        backgroundColor={
          activeButton === "Business"
            ? "rgba(0, 173, 239, 1)"
            : "rgba(239, 243, 253, 1)"
        }
        color={activeButton === "Business" ? "white" : "black"}
        onClick={() => handleButtonClick("Business")}
      />
    </ToggleButtonDiv>
  );
};

export default ToggleButton;
